import AxiosCustom from "common/components/apiConfig";

export function insert_pishro_force_set_password(payload) {
  let config = {
    url: "update_request",
  };
  let data = {
    table: "clubmember",
    method_type: "pishro_force_set_password",
    data: payload.data ? payload.data : {},
  };

  return AxiosCustom(config, data);
}
